import clsx from 'clsx'
import BaseDivider, { DividerProps as BaseDividerProps } from 'antd/lib/divider'

export interface DividerProps extends Omit<BaseDividerProps, 'type'> {
  space?: 'small' | 'medium' | 'large' | 'none'
}

export const Divider = ({
  space = 'medium',
  className,
  ...rest
}: DividerProps): JSX.Element => (
  <>
    <BaseDivider
      className={clsx(
        className,
        space === 'small' && ['mt-3', 'mb-3'],
        space === 'medium' && ['mt-6', 'mb-6'],
        space === 'large' && ['mt-9', 'mb-9'],
        space === 'none' && ['mt-0', 'mb-0']
      )}
      type="horizontal"
      {...rest}
    />
  </>
)

export default Divider
